<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('shouye') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('zi-yuan-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('chong-dian-zhan-guan-li') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane :label="$t('chong-dian-zhan-guan-li-0')" name="stationList">
              <!--      查询组件       -->
              <el-row>
                <search
                  @submitStationSearchForm="submitStationSearchForm"
                  :stationSearchForm="stationSearchForm"
                  :operatorForSelect="operatorForSelect"
                  :stationStatusData="enumData.stationStatusData"
                  :stationTypeData="enumData.stationTypeData"
                  :getStationsLoading="getStationsLoading"
                  ref="searchForm"
                >
                </search>
                <!--       新增组件         -->
                <el-form>
                  <el-col :span="2.5" class="diy-class" style="margin-right: 10px;">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="newStationAdd" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:station:quickSaveStation'])">
                        {{ $t('kuai-su-jian-zhan') }}
                      </el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" class="diy-class">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="stationAdd" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:station:saveOrUpdateStation'])">
                        {{ $t('xin-zeng-dian-zhan') }}
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
              <!--       列表组件       -->
              <list
                @submitStationSearchForm="submitStationSearchForm"
                @showViewVisible="showViewVisible"
                @stationEdit="stationEdit"
                @stationDelete="stationDelete"
                @rateEdit="rateEdit"
                :tableData="tableData"
                :stationsLoading="stationsLoading"
              ></list>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>

            <el-tab-pane :label="$t('chong-dian-zhan-an-quan-guan-li')" name="safetyList" v-if="checkPermission(['bee:res:stationSafety:page'])">
              <!--      查询组件       -->
              <el-row>
                <safetySearch
                  @submitSafetySearchForm="submitSafetySearchForm"
                  :stationSearchForm="stationSearchForm"
                  :stationsForSelect="stationsForSelect"
                  :operatorForSelect="operatorForSelect"
                  :getStationsLoading="getStationsLoading"
                  @operatorSelect="operatorSelect"
                  ref="searchForm"
                >
                </safetySearch>
                <!--       新增组件         -->
                <el-form>
                  <el-col :span="2" class="diy-class">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="safetyAdd" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:station:saveOrUpdateStation'])">
                        {{ $t('xin-zeng-guan-li') }}
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
              <!--       列表组件       -->
              <safetyList
                @safetyEdit="safetyEdit"
                @stationEdit="stationEdit"
                @stationDelete="stationDelete"
                @submitSafetySearchForm="submitSafetySearchForm"
                :tableSafetyData="tableSafetyData"
                :stationsLoading="stationsLoading"
              ></safetyList>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>

            <!--<el-tab-pane label="登记充电站" name="second">登记充电站</el-tab-pane>-->
          </el-tabs>
        </el-col>
      </el-row>
      <rateAdd
        :editForm="rateEditForm"
        :timeForm="timeForm"
        :editFormVisible="rateEditFormVisible"
        :operatorForSelect="operatorForSelect"
        :standardAble="standardAble"
        :editSubmitLoading="rateEditSubmitLoading"
        :tableData="tableRateData"
        :timesAble="timesAble"
        :topCheckFlag="topCheckFlag"
        :summitCheckFlag="summitCheckFlag"
        :flatCheckFlag="flatCheckFlag"
        :valleyCheckFlag="valleyCheckFlag"
        :YesNoEnumData="rateYesNoEnumData"
        :pileType="pileType"
        @closeEditForm="closeEditForm"
        @editSubmit="rateEditSubmit"
        @timeMouseenter="timeMouseenter"
        @timeMousedown="timeMousedown"
        @topCheck="topCheck"
        @summitCheck="summitCheck"
        @flatCheck="flatCheck"
        @valleyCheck="valleyCheck"
        @standardInputChange="standardInputChange"
        @timesInputChange="timesInputChange"
        ref="add"
      ></rateAdd>
      <!--新增组件-->
      <add
        @editSubmit="editSubmit"
        @closeEditForm="closeEditForm"
        :editForm="editForm"
        :editFormVisible="editFormVisible"
        :editSubmitLoading="editSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationTypeData="enumData.stationTypeData"
        :stationStatusData="enumData.stationStatusData"
        :addressTypeData="enumData.addressTypeData"
        :businessTypeData="enumData.businessTypeData"
        :YesNoEnumData="enumData.YesNoEnumData"
        :feesTakeUpPileData="enumData.feesTakeUpPileData"
        :feesParkData="enumData.feesParkData"
        :fastOrSlowData="enumData.fastOrSlowData"
        :isCecData="enumData.isCecData"
        :isProfitData="enumData.isProfitData"
        :profitTypeEnum="enumData.profitTypeEnum"
        :extractTypeEnum="enumData.extractTypeEnum"
      ></add>
      <!--   视图组件   -->
      <customizeView
        @closeView="closeView"
        @unbinding="unbinding"
        @dobinding="dobinding"
        @submitStationSearchForm="submitStationSearchForm"
        @revertUploadAvatarFormFileList="revertUploadAvatarFormFileList"
        @revertUploadSitePicFormFileList="revertUploadSitePicFormFileList"
        @revertStationPicturesFormFileList="revertStationPicturesFormFileList"
        :protocolEnumData="enumData.protocolEnumData"
        :pileModelEnumData="enumData.pileModelEnumData"
        :YesNoEnumData="enumData.YesNoEnumData"
        :view-visible="viewVisible"
        :detailForm="detailForm"
        :searchTabsAddForm="searchTabsAddForm"
        :bindingRateForm="bindingRateForm"
        :serviceBillingRulesSelect = "serviceBillingRulesSelect"
        :uploadAvatarForm="uploadAvatarForm"
        :uploadSitePicForm="uploadSitePicForm"
        :newUploadSitePicturesForm="newUploadSitePicturesForm"
        :uploadAvatarFormFileList="uploadAvatarFormFileList"
        :uploadSitePicFormFileList="uploadSitePicFormFileList"
        :newUploadSitePicturesList="newUploadSitePicturesList"
        :stationImageUrlList="stationImageUrlList"
        :createPileAndGunForm="createPileAndGunForm"
      >
      </customizeView>
      <!--快速建站-->
      <quick-add
        @newEditSubmit="newEditSubmit"
        @closeNewEditForm="closeNewEditForm"
        :newEditForm="newEditForm"
        :newEditFormVisible="newEditFormVisible"
        :newEditSubmitLoading="newEditSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationTypeData="enumData.stationTypeData"
        :stationStatusData="enumData.stationStatusData"
        :addressTypeData="enumData.addressTypeData"
        :businessTypeData="enumData.businessTypeData"
        :YesNoEnumData="enumData.YesNoEnumData"
        :feesTakeUpPileData="enumData.feesTakeUpPileData"
        :feesParkData="enumData.feesParkData"
        :fastOrSlowData="enumData.fastOrSlowData"
        :isCecData="enumData.isCecData"
      ></quick-add>

      <!--新增组件-->
      <addSafety
        @safetyEditSubmit="safetyEditSubmit"
        @closeSafetyEditForm="closeSafetyEditForm"
        @submitSafetySearchForm="submitSafetySearchForm"
        @operatorSelect="operatorSelect"
        :safetyEditForm="safetyEditForm"
        :safetyEditFormVisible="safetyEditFormVisible"
        :safetyEditSubmitLoading="safetyEditSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationSearchForm="stationSearchForm"
        :stationsForSelect="stationsForSelect"
        :auditStatusEnum="enumData.auditStatusEnum"
        :stationImageUrlList="stationImageUrlList"
        :newUploadSitePicturesList="newUploadSitePicturesList"
        :profitTypeEnum="enumData.profitTypeEnum"
        :extractTypeEnum="enumData.extractTypeEnum"
      ></addSafety>

      <el-dialog width="40%" :visible.sync="dialogInnerVisible">
        <!--快速搜索 form-->
        <el-form :model="innerForm" ref="innerForm" :inline="true" size="mini">
          <el-tabs v-model="innerFormName">
            <!--经纬坐标-->
            <el-tab-pane :label="$t('jing-wei-zuo-biao')" name="coordinate">
              <el-row class="el_row_input row_input">
                <el-col :span="10" class="el_col_input">
                  <el-form-item :label="$t('jing-du')">
                    <el-input autocomplete="off" v-model="centerTemp.lng"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2" class="el_col_input">
                  <el-form-item :label="$t('wei-du')">
                    <el-input autocomplete="off" v-model="centerTemp.lat"></el-input>
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="2">-->
                <!--                  <el-form-item>-->
                <!--                    <el-button size="mini" class="el_search">搜索</el-button>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
              </el-row>
              <!--百度地图组件-->
              <div class="BaiduMap">
                <baidu-map class="map" :center="centerTemp" :zoom="15" :scroll-wheel-zoom="true"
                           :map-style="{styleJson:styleJson}"
                           map-type="BMAP_NORMAL_MAP" @click="getClickInfo">
                  <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                                  :autoLocation="true"></bm-geolocation>
                  <!--&lt;!&ndash;//添加一个小红点的，并将当前的经纬度写入数据中&ndash;&gt;-->
                  <bm-marker :position="centerTemp"></bm-marker>
                  <bm-control :offset="{width: '10px', height: '10px'}">
                    <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 9999}">
                      <el-input size="mini" v-model="keyword" :placeholder="$t('qing-shu-ru-di-ming-guan-jian-zi')"></el-input> <!-- 这里指代一个自定义搜索框组件 -->
                    </bm-auto-complete>
                  </bm-control>
                  <bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>
                </baidu-map>
              </div>
              <!--内部对话框底部当前位置-->
              <el-row class="el_row_input rows_input">
                <el-col :span="24" class="el_col_input">
                  <el-form-item>
                    <label style="color: sienna;font-weight: bold" v-text="addressTemp"></label>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" plain @click="dialogInnerVisible = false">{{ $t('qu-xiao') }}</el-button>
          <el-button size="mini" plain type="primary" @click="confirmAddress">{{ $t('ti-jiao') }}</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import Pagination from '../../../components/Pagination'
import search from "./siteManager/search"
import safetySearch from "./safetyManager/search"
import list from "./siteManager/list"
import safetyList from "./safetyManager/list"
import add from "./siteManager/add"
import addSafety from "./safetyManager/add"
import quickAdd from "./siteManager/quickAdd"
import rateAdd from "./rateManager/add"
import customizeView from "./siteManager/customizeView"
import stationApi from '../../resourceCenter/api/stationApi'
import safetyApi from '../../resourceCenter/api/safetyApi'
import commonApi from '../../resourceCenter/api/commonApi'
import sysConfig from '@/../config/sysConfig'
import rateApi from "../api/rateApi";

export default {
  name: 'siteManager',
  data() {
    return {
      stationsForSelect: '',
      enumData: [{
        canUseData: '',
        stationStatusData: '',
        stationTypeData: '',
        feesTakeUpPileData: '',
        feesParkData: '',
        fastOrSlowData: '',
        isCecData: '',
        isProfitData: '',
        YesNoEnumData: '',
        addressTypeData:'',
        businessTypeData:'',
        protocolEnumData:'',
        pileModelEnumData:'',
        auditStatusEnum:'',
        profitTypeEnum:'',
        extractTypeEnum:''
      }],
      operatorForSelect: [],
      auditStatusEnum: [],
      // restaurants: [],
      tableData: [{}],
      tableSafetyData: [{}],
      stationsLoading: false,
      stationSearchForm: {},
      getStationsLoading: false,
      editForm: {},
      newEditForm:{},
      safetyEditForm: {},
      editSubmitLoading: false,
      detailForm: {},
      innerForm: {},
      searchTabsAddForm: {
        searchTabs: []
      },

      editFormVisible: false, // 外部对话框
      dialogInnerVisible: false, // 内部对话框
      viewVisible: false, // 视图
      multipleSelection: [],
      activeName: 'stationList',
      innerFormName: 'coordinate',
      detailFormName: 'stationBasicInformation',
      viewName: 'detailForm',
      showFilters: true,
      input: '',
      // 百度地图初始化数据
      baidumapSwitch: false,
      zoom: 16,
      location: this.$t('shang-hai-shi'),
      keyword: '',
      centerTemp: {
        lng: 121.384555, lat: 31.069087
      },
      // 设置center属性值
      provinceTemp: '',
      cityTemp: '',
      districtTemp: '',
      addressTemp: '',
      val_time: '', // 创建时间
      formLabelWidth: '155px',
      styleJson: [ // 百度地图自定义
        {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': {
            'color': '#ffffff'
          }
        }
      ],
      bindingRateForm: {},
      serviceBillingRulesSelect: {},
      uploadAvatarForm: {},
      uploadSitePicForm: {},
      stationUploadImageForm:{},
      newUploadSitePicturesForm: {},
      uploadAvatarFormFileList: [],
      uploadSitePicFormFileList: [],
      newUploadSitePicturesList:[],
      stationImageUrlList:[],
      createPileAndGunForm:{},
      newEditFormVisible: false,
      safetyEditFormVisible: false,
      newEditSubmitLoading: false,
      safetyEditSubmitLoading: false,
      // 分页参数
      pageparam: {
        t: {},
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      //rate begin
      rate: {},
      rolClassName: 'timeLabInCol el-col el-col-6',
      topCheckFlag: true, // 尖时被选中
      summitCheckFlag: true, // 峰被选中
      flatCheckFlag: true, // 平被选中
      valleyCheckFlag: true, // 谷被选中
      checkFlag: '', // 当前应该赋值的className
      timesAble: true,
      standardAble: true,
      // 多选集合
      rateYesNoEnumData:[
        {value: 'Y', message: this.$t('shi')},
        {value: 'N', message: this.$t('fou')}
      ],
      // 编辑
      rateEditFormVisible: false,
      rateEditSubmitLoading: false,
      rateEditForm: {
        timeList: null,
        type:"",
        pileType:"Q"
      },
      timeForm: {},
      tableRateData: [
        {
          date1: '0:00-0:30',
          date2: '0:30-1:00',
          date3: '1:00-1:30',
          date4: '1:30-2:00'
        },
        {
          date1: '2:00-2:30',
          date2: '2:30-3:00',
          date3: '3:00-3:30',
          date4: '3:30-4:00'
        },
        {
          date1: '4:00-4:30',
          date2: '4:30-5:00',
          date3: '5:00-5:30',
          date4: '5:30-6:00'
        },
        {
          date1: '6:00-6:30',
          date2: '6:30-7:00',
          date3: '7:00-7:30',
          date4: '7:30-8:00'
        },
        {
          date1: '8:00-8:30',
          date2: '8:30-9:00',
          date3: '9:00-9:30',
          date4: '9:30-10:00'
        },
        {
          date1: '10:00-10:30',
          date2: '10:30-11:00',
          date3: '11:00-11:30',
          date4: '11:30-12:00'
        },
        {
          date1: '12:00-12:30',
          date2: '12:30-13:00',
          date3: '13:00-13:30',
          date4: '13:30-14:00'
        },
        {
          date1: '14:00-14:30',
          date2: '14:30-15:00',
          date3: '15:00-15:30',
          date4: '15:30-16:00'
        },
        {
          date1: '16:00-16:30',
          date2: '16:30-17:00',
          date3: '17:00-17:30',
          date4: '17:30-18:00'
        },
        {
          date1: '18:00-18:30',
          date2: '18:30-19:00',
          date3: '19:00-19:30',
          date4: '19:30-20:00'
        },
        {
          date1: '20:00-20:30',
          date2: '20:30-21:00',
          date3: '21:00-21:30',
          date4: '21:30-22:00'
        },
        {
          date1: '22:00-22:30',
          date2: '22:30-23:00',
          date3: '23:00-23:30',
          date4: '23:30-24:00'
        }
      ],
      pileType:'Q'
      //rate end
    }
  },
  methods: {
    closeView(){
      this.viewVisible=false
      this.uploadAvatarFormFileList=[],
        this.uploadSitePicFormFileList=[],
        this.newUploadSitePicturesList=[],
        this.stationImageUrlList=[]
    },
    newStationAdd(){
      this.$nextTick(() => {
        this.newEditFormVisible = true;
        this.newEditForm = Object.assign({})
      })
    },
    safetyAdd() {
      this.$nextTick(() => {
        this.safetyEditFormVisible = true;
      })
    },

    safetyEdit(index, row) {
      this.$nextTick(() => {
        this.safetyEditForm = Object.assign({},row)
        let domain = sysConfig.apiPre;
        if (domain === "http://localhost") {
          domain = 'http://qectest.qingec.com/';
        }
        let picJson = this.safetyEditForm.pictures
        for (let index in picJson) {
          this.uploadSitePicFormFileList.push({name: "", url: domain + '/' + picJson[index]});
          this.newUploadSitePicturesList.push(
            {
              name: picJson[index],
              url: domain + '/' + picJson[index]
            }
          );
        }
        this.safetyEditFormVisible = true;
      })
    },

    //一键创建桩和枪
    createPileAndGun(index, row){
      this.createPileAndGunForm = {
        id: row.id,
        stationName: row.stationName,
        oneGunNum: row.oneGunNum,
        secondGunNum: row.secondGunNum,
        threeGunNum: row.threeGunNum,
        fourGunNum: row.fourGunNum
      }
    },
    safetyEditSubmit(safetyEditSubmit) {
      console.log("进入提交数据方法: " + JSON.stringify(this.safetyEditSubmit))
      safetyEditSubmit.validate((valid) => {
        if (!valid) {
          return;
        } else {
          this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
            this.safetyEditSubmitLoading = true;
            let param = JSON.stringify(this.safetyEditSubmit);
            stationApi.quickSaveStation(param).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                });
                this.newEditFormVisible = false;
                this.submitSafetySearchForm()
              } else {
                this.$message.error(res.message)
              }
              this.safetyEditSubmitLoading = false;
            })
          })
        }
      })
    },

    newEditSubmit(newEditSubmit) {
      newEditSubmit.validate((valid) => {
        if (!valid) {
          return;
        } else {
          /*if(this.editForm.address == null || this.editForm.address === 'undefined'){
            this.$message({
              message: "请选择充电站地址",
              type: 'error'
            });
            return;
          }*/
          this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
            this.newEditSubmitLoading = true;
            let param = JSON.stringify(this.newEditForm);
            stationApi.quickSaveStation(param).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                });
                this.newEditFormVisible = false;
                this.submitStationSearchForm()
              } else {
                this.$message.error(res.message)
              }
              this.newEditSubmitLoading = false;
            })
          })
        }
      })
    },
    submitStationSearchForm() {
      this.$refs.searchForm.$children[0].validate((valid) => {
        if (!valid) {
          return;
        }
        this.getStationsLoading = true
        this.stationsLoading = true
        // let param = Object.assign({}, this.stationSearchForm)
        // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
        this.pageparam.t = this.stationSearchForm;
        let param = Object.assign({}, this.pageparam)
        stationApi.getStations(param).then((res) => {
          console.info(JSON.stringify(res.data.records))
          if (res.code === 0) {
            this.pageparam.total = res.data.total;
            this.tableData = res.data.records;
            // this.$message({
            //   message: res.message,
            //   type: 'success'
            // })
          } else {
            // this.$message.error(res.message)
          }
          this.getStationsLoading = false
          this.stationsLoading = false
        })
      })
    },
    submitSafetySearchForm() {
      this.$refs.searchForm.$children[0].validate((valid) => {
        if (!valid) {
          return;
        }
        this.getStationsLoading = true
        this.stationsLoading = true
        this.pageparam.t = this.stationSearchForm;
        let param = Object.assign({}, this.pageparam)
        safetyApi.getPage(param).then((res) => {
          if (res.code === 0) {
            this.pageparam.total = res.data.total;
            this.tableSafetyData = res.data.list;
          } else {
          }
          this.getStationsLoading = false
          this.stationsLoading = false
        })
      })
    },

    dialogInnerClick(tab, event) {
    },
    // 编辑
    stationAdd() {
      this.$nextTick(() => {
        this.editFormVisible = true
        this.editForm = Object.assign({})
      })
    },
    showViewVisible(index, row) {
      this.stationDetail(index, row)
      this.searchTabsAdd(index, row)
      this.bindingRate(index, row)
      this.uploadAvatar(index, row)
      //this.uploadSitePic(index, row)
      this.createPileAndGun(index,row)
      this.newUploadSitePictures(index,row)
      this.viewVisible = true
    },
    /*newUploadSitePictures(index,row){
      console.log("open view about station upload images");
    },*/
    stationEdit(index, row) {
      this.editFormVisible = true
      console.log("row:" + JSON.stringify(row))
      this.editForm = Object.assign({}, row)
      this.editForm.canUse = this.editForm.canUseCode
      this.editForm.stationType = this.editForm.stationTypeCode
      this.editForm.stationStatus = this.editForm.stationStatusCode
      this.editForm.feesTakeUpPile = this.editForm.feesTakeUpPileCode
      this.editForm.feesPark = this.editForm.feesParkCode
      this.editForm.addressType = this.editForm.addressTypeCode
      this.editForm.isCec = this.editForm.isCecCode
      this.editForm.isCecAlarmCode = this.editForm.isCecAlarmCode
      this.editForm.fastOrSlow = this.editForm.fastOrSlowCode
      this.editForm.businessType = this.editForm.businessTypeCode
      this.editForm.commissionChargeFlag = this.editForm.commissionChargeFlagCode
      this.editForm.isParkingFee = this.editForm.isParkingFeeCode
      this.editForm.addressType = this.editForm.addressTypeCode
      this.editForm.supportOrder = this.editForm.supportOrderCode
      this.editForm.isInvoice = this.editForm.isInvoiceCode
      this.editForm.isNaming = this.editForm.isNamingCode
      this.editForm.isTimingStart = this.editForm.isTimingStartCode
      this.editForm.isThirdparty = this.editForm.isThirdpartyCode
      this.editForm.simExpire = this.editForm.simExpireCode
      this.editForm.gaodeDock = this.editForm.gaodeDockCode;
      this.editForm.timelyProfit = this.editForm.timelyProfitCode;
    },
    stationDetail(index, row) {
      this.detailForm = Object.assign({}, row)
    },
    editSubmit(editForm) {
      editForm.validate((valid) => {
        if (!valid) {
          return;
        } else {
          this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
            this.editSubmitLoading = true
            let param = JSON.stringify(this.editForm)
            stationApi.saveOrUpdateStation(param).then((res) => {
                this.editSubmitLoading = false
                if (res.code === 0) {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  })
                  this.submitStationSearchForm();
                } else {
                  this.$message.error(res.message)
                }
                this.editFormVisible = false
              }
            )
          })
        }
      })
    },
    // closeDialog(add){
    //   if (add === "add"){
    //     this.editFormVisible = false
    //   }
    // },
    // 删除
    stationDelete(index, row) {
      this.$confirm(this.$t('que-ding-yao-shan-chu') + row.stationName + this.$t('ma'), this.$t('alaramMonitor.message5'), {
        confirmButtonText: this.$t('deviceControl.confirm'),
        cancelButtonText: this.$t('alaramMonitor.cancel'),
        type: 'warning'
      })
        .then(() => {
          stationApi.deleteStation(row.id).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.submitStationSearchForm();
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('alaramMonitor.message8')
          })
        })
    },
    closeEditForm() {
      this.editFormVisible = false
      this.rateEditFormVisible = false
    },
    closeSafetyEditForm() {
      this.safetyEditForm = Object.assign({})
      this.newUploadSitePicturesList = []
      this.safetyEditFormVisible = false
    },
    closeNewEditForm() {
      this.newEditFormVisible = false
    },
    showInnerForm() {
      this.centerTemp.lng = this.editForm.longitude == null ? 121.384555 : this.editForm.longitude
      this.centerTemp.lat = this.editForm.latitude == null ? 31.069087 : this.editForm.latitude
      this.provinceTemp = this.editForm.province
      this.cityTemp = this.editForm.city
      this.districtTemp = this.editForm.area
      this.addressTemp = this.editForm.address
      this.dialogInnerVisible = true
    },
    // 点击获取到当前经纬度
    getClickInfo(e) {
      const myGeo = new window.BMap.Geocoder()
      myGeo.getLocation(e.point, data => {
        if (data) {
          this.centerTemp = {lng: e.point.lng, lat: e.point.lat}
          this.provinceTemp = data.addressComponents.province
          this.cityTemp = data.addressComponents.city
          this.districtTemp = data.addressComponents.district
          this.addressTemp = data.address
        }
      })
    },
    confirmAddress() {
      this.editForm.longitude = this.centerTemp.lng
      this.editForm.latitude = this.centerTemp.lat
      this.editForm.province = this.provinceTemp
      this.editForm.city = this.cityTemp
      this.editForm.area = this.districtTemp
      this.editForm.address = this.addressTemp;
      if (this.editForm.address) this.$refs.editForm.clearValidate("address")
      this.dialogInnerVisible = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    changePage() {
      this.submitStationSearchForm()
    },
    // 显示绑定费率页面
    bindingRate(index, row) {
      this.bindingRateForm = {
        id: row.id,
        serviceBillingRulesId: row.serviceBillingRulesId,
        ruleName: '',
        operatorId: row.operatorId
      }
      if (this.bindingRateForm.serviceBillingRulesId) { // 若果已经绑定了费率，则查询费率名称，显示解绑页面
        let params = {
          stationType: row.stationType.code,
          id: this.bindingRateForm.serviceBillingRulesId
        };
        stationApi.getRateNameById(params).then((res) => {
          this.bindingRateForm.ruleName = res.ruleName
        })
      } else {  // 如果没有绑定费率，则查询运营商关联的费率列表，显示绑定页面
        // 获取当前登陆/或选择的运营商ID
        let params = {
          stationType: row.stationType.code,
          operatorIds: [this.bindingRateForm.operatorId]
        };
        console.log("绑定资费请求参数:" + JSON.stringify(params))
        stationApi.getRateSelectByOperatorId(params).then((res) => {
          this.serviceBillingRulesSelect = res
        })
      }
    },
    // 解绑费率
    unbinding() {
      this.$confirm(this.$t('que-ding-yao-jie-bang') + this.bindingRateForm.ruleName + this.$t('ma-0'), this.$t('deviceControl.prompt'), {
        confirmButtonText: this.$t('deviceControl.confirm'),
        cancelButtonText: this.$t('alaramMonitor.cancel'),
        type: 'warning'
      })
        .then(() => {
          let param = Object.assign({}, this.bindingRateForm)
          param.serviceBillingRulesId = null
          stationApi.bindingRate(param).then((res) => {
            if (res) {
              this.$message({
                message: this.$t('jie-bang-cheng-gong'),
                type: 'success'
              })
              this.bindingRateForm.serviceBillingRulesId = null
              this.viewVisible=false
              this.submitStationSearchForm()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('yi-qu-xiao-cao-zuo')
          })
        })
    },
    // 绑定费率
    dobinding(bindingRateForm) {
      bindingRateForm.validate((valid) => {
        if (!valid) {
          return;
        } else {
          this.$confirm(this.$t('que-ding-yao-bang-ding-ma'), this.$t('deviceControl.prompt'), {
            confirmButtonText: this.$t('deviceControl.confirm'),
            cancelButtonText: this.$t('alaramMonitor.cancel'),
            type: 'warning'
          })
            .then(() => {
              let param = Object.assign({}, this.bindingRateForm)
              param.serviceBillingRulesId = this.bindingRateForm.serviceBillingRulesIdTemp
              stationApi.bindingRate(param).then((res) => {
                if (res) {
                  this.$message({
                    message: this.$t('bang-ding-cheng-gong'),
                    type: 'success'
                  })
                  this.bindingRateForm.serviceBillingRulesId = this.bindingRateForm.serviceBillingRulesIdTemp
                  this.viewVisible=false
                  this.submitStationSearchForm()
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('yi-qu-xiao-cao-zuo-0')
              })
            })
        }
      })
    },
    // 显示标签页
    searchTabsAdd(index, row) {
      this.searchTabsAddForm.stationId = row.id
      stationApi.getSearchTabs(row.id).then((res) => {
        if (res.code === 0) {
          this.searchTabsAddForm.searchTabs = res.data
        }
      })
    },
    //重置头像
    revertUploadAvatarFormFileList(){
      this.uploadAvatarFormFileList=[]
    },
    //重置图片
    revertUploadSitePicFormFileList(){
      this.uploadSitePicFormFileList=[]
    },
    revertStationPicturesFormFileList(){
      this.newUploadSitePicturesList=[]
    },
    // 自动填充input
    queryRateGroupId(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    loadAll() {
      let param = {operatorId: this.editForm.operatorId}
      stationApi.queryRateGroupId(param).then((res) => {
        if (res.code === 0) {
        } else {
        }
      })
      return []
    },
    handleSelect(item) {
    },
    // 加载下拉框
    loadSelectItem() {

      //加载充电站下拉框
      stationApi.getStationEnum().then((res) => {
        this.enumData.canUseData = JSON.parse(res.canUseData)
        this.enumData.stationStatusData = JSON.parse(res.stationStatusData)
        this.enumData.stationTypeData = JSON.parse(res.stationTypeData)
        this.enumData.feesTakeUpPileData = JSON.parse(res.feesTakeUpPileData)
        this.enumData.feesParkData = JSON.parse(res.feesTakeUpPileData)
        this.enumData.isCecData = JSON.parse(res.isCecData)
        this.enumData.isProfitData = JSON.parse(res.isCecData)
        this.enumData.fastOrSlowData = JSON.parse(res.fastOrSlowData)
        this.enumData.YesNoEnumData = JSON.parse(res.YesNoEnumData)
        this.enumData.addressTypeData = JSON.parse(res.addressTypeData)
        this.enumData.businessTypeData = JSON.parse(res.businessTypeData)
        this.enumData.protocolEnumData = JSON.parse(res.protocolEnumData)
        this.enumData.pileModelEnumData = JSON.parse(res.pileModelEnumData)
        this.enumData.profitTypeEnum = JSON.parse(res.profitTypeEnum)
        this.enumData.extractTypeEnum = JSON.parse(res.extractTypeEnum)
      })
      // 站下拉框
      commonApi.stationsForSelectByOperatorId(this.$store.getters.operatorIds).then((res) => {
        if (res.code === 0) {
          this.stationsForSelect = res.data
        }
      })
      // 运营商下拉框
      commonApi.getOperatorsTree().then((res) => {
        if (res.code === 0) {
          this.operatorForSelect = res.data
        }
      })

      // 审核状态下拉框
      safetyApi.getSafetyEnum().then((res) => {
        this.enumData.auditStatusEnum = JSON.parse(res.auditStatusEnum)
      })

    },
    operatorSelect(val) {
      commonApi.stationsForSelectByOperatorId([val]).then((res) => {
        if (res.code === 0) {
          this.stationsForSelect = res.data
        }
      })
    },
    uploadFile(file){
      return new Promise(function(resolve, reject) {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function() {
          resolve(this.result)
        }
      })
    },

    uploadAvatar(index, row){
      let domain = sysConfig.apiPre;
      if(domain==="http://localhost"){
        domain='http://qectest.qingec.com/';
      }
      stationApi.getLogo(row.id).then((res) => {
        if (res.code === 0) {
          if (res.data==null || res.data===''){
            this.uploadAvatarFormFileList=[]
          }else {
            this.uploadAvatarFormFileList= [{name: "", url: domain + '/' + res.data}]
          }
          this.uploadAvatarForm={
            id:row.id,
            stationCode:row.stationCode,
            logo:this.uploadAvatarFormFileList
          }
        } else {
          this.uploadAvatarFormFileList=[]
        }
      })
    },

    newUploadSitePictures(index, row){
      let domain = sysConfig.apiPre;
      if(domain==="http://localhost"){
        domain='http://qectest.qingec.com/';
      }
      stationApi.getPicture(row.id).then((res) => {
        if (res.code === 0) {
          this.uploadSitePicFormFileList=[]
          let picJson = []
          if (res.data==null||res.data==""){

          }else {
            picJson = JSON.parse(res.data)
          }
          for (let index in picJson){
            this.uploadSitePicFormFileList.push({name:"",url:domain+'/'+picJson[index]});
            this.newUploadSitePicturesList.push(
              {
                name:picJson[index],
                url:domain+'/'+picJson[index]
              }
            );
            this.stationImageUrlList.push(picJson[index]);
          }
          this.uploadSitePicForm={
            id:row.id,
            stationCode:row.stationCode,
            picture:this.uploadSitePicFormFileList
          }
          this.newUploadSitePicturesForm={
            id:row.id,
            picture:this.newUploadSitePicturesList
          }
        } else {
          this.uploadSitePicFormFileList=[];
          this.newUploadSitePicturesList=[];
        }
      })
    },
    //rate begin
    async rateEdit(rateId) {
      this.loading = true
      try {
        const {data} = await rateApi.getRateById(rateId)
        this.rate = data ? data : {}
        this.pileType = this.rate.pileType
        this.rateEditFormVisible = true
        this.rateEditForm = Object.assign({}, this.rate);
        this.rateEditForm.type = this.rateEditForm.typeCode;
        this.rateEditForm.showElectricLossRate = this.rateEditForm.showElectricLossRateCode;
        let param = {serviceBillingRulesId: this.rate.id};
        if (this.rate.typeCode == 'standard') {
          this.timesAble = true
          this.standardAble = false
          this.standardInputChange()
        } else if (this.rate.typeCode == 'times') {
          this.timesAble = false
          this.standardAble = true
          this.timesInputChange()
          rateApi.getTimeSharing(param).then((res) => {
            if (res.code === 0) {
              this.$nextTick(() => {
                for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
                  switch (res.data[0]['time' + i]) {
                    case '0' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('topCheck')
                      break
                    case '1' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('summitCheck')
                      break
                    case '2' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('flatCheck')
                      break
                    case '3' :
                      this.$refs.add.$refs.timeLabInCol[i].$el.classList.add('valleyCheck')
                      break
                    default :
                      console.log(this.$refs.add.$refs.timeLabInCol[i].$el.classList)
                      break
                  }
                }
              })
            }
          })
        }
      } finally {
        this.loading = false
      }
    },
    standardInputChange() {
      this.timesAble = true
      this.standardAble = false
      let temp = Object.assign({}, this.rateEditForm)
      temp.topElectricityFees = ''
      temp.summitElectricityFees = ''
      temp.flatElectricityFees = ''
      temp.valleyElectricityFees = ''
      temp.topServiceFees = ''
      temp.summitServiceFees = ''
      temp.flatServiceFees = ''
      temp.valleyServiceFees = ''
      console.log("rateEditForm.type:" + this.rateEditForm.type)
      this.rateEditForm = temp
      this.topCheckFlag = true
      this.summitCheckFlag = true
      this.flatCheckFlag = true
      this.valleyCheckFlag = true
      this.$nextTick(() => {
        for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
          this.$refs.add.$refs.timeLabInCol[i].$el.className = this.rolClassName
        }
      })
    },
    timesInputChange() {
      this.standardAble = true
      this.timesAble = false
      let temp = Object.assign({}, this.rateEditForm)
      this.rateEditForm = temp
      temp.standardElectricityFees = ''
      temp.standardServiceFees = ''
      console.log("rateEditForm.type:" + this.rateEditForm.type)
      this.rateEditForm = temp
      this.topCheckFlag = false
      this.summitCheckFlag = false
      this.flatCheckFlag = false
      this.valleyCheckFlag = false
    },
    topCheck() {
      this.checkFlag = 'topCheck'
      this.summitCheckFlag = !this.summitCheckFlag
      this.flatCheckFlag = !this.flatCheckFlag
      this.valleyCheckFlag = !this.valleyCheckFlag
    },
    summitCheck() {
      this.checkFlag = 'summitCheck'
      this.topCheckFlag = !this.topCheckFlag
      this.flatCheckFlag = !this.flatCheckFlag
      this.valleyCheckFlag = !this.valleyCheckFlag
    },
    flatCheck() {
      this.checkFlag = 'flatCheck'
      this.topCheckFlag = !this.topCheckFlag
      this.summitCheckFlag = !this.summitCheckFlag
      this.valleyCheckFlag = !this.valleyCheckFlag
    },
    valleyCheck() {
      this.checkFlag = 'valleyCheck'
      this.topCheckFlag = !this.topCheckFlag
      this.summitCheckFlag = !this.summitCheckFlag
      this.flatCheckFlag = !this.flatCheckFlag
    },
    timeClick(event) {
      if (this.topCheckFlag && this.summitCheckFlag && this.flatCheckFlag && this.valleyCheckFlag) {
        this.$message.error(this.$t('xian-xuan-ze-shi-duan-biao-zhi-zai-dian-ji-shi-duan-she-zhi'))
      } else {
        if (event.currentTarget.classList.contains(this.checkFlag)) { // 如果已经绑定过当前css 则移除
          event.currentTarget.classList.remove(this.checkFlag)
        } else {
          if (event.currentTarget.classList.length > 3) { // 如果已经绑定过css 则初始化后再绑定
            event.currentTarget.className = this.rolClassName + ' ' + this.checkFlag
          } else {
            event.currentTarget.classList.add(this.checkFlag)
          }
        }
      }
    },
    timeMouseenter(event) {
      if (event.which === 1) {
        this.timeClick(event)
      }
    },
    timeMousedown(event) {
      this.timeClick(event)
    },
    rateEditSubmit(rateEditForm) {
      rateEditForm.validate((valid) => {
        if (!valid) {
          return;
        } else {
          console.log(this.rateEditForm.type)
          if (typeof(this.rateEditForm.type) =="undefined"){
            this.$message.error(this.$t('qing-xian-she-zhi-fei-shuai'))
            return;
          }
          this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
            this.editSubmitLoading = true
            for (let i = 0; i < this.$refs.add.$refs.timeLabInCol.length; i++) {
              let classList = this.$refs.add.$refs.timeLabInCol[i].$el.classList
              switch (classList[classList.length - 1]) {
                case 'topCheck' :
                  this.timeForm['time' + i] = '0'
                  break
                case 'summitCheck' :
                  this.timeForm['time' + i] = '1'
                  break
                case 'flatCheck' :
                  this.timeForm['time' + i] = '2'
                  break
                case 'valleyCheck' :
                  this.timeForm['time' + i] = '3'
                  break
                default :
                  this.timeForm['time' + i] = '2'
                  break
              }
            }
            this.rateEditForm.timeList = this.timeForm
            let param = Object.assign({}, this.rateEditForm)
            // let param = JSON.stringify(this.rateEditForm)

            //新增、编辑调用两个不同的接口
            if(this.rateEditForm.id == null || this.rateEditForm.id ==''){
              rateApi.saveRate(param).then(res => {
                this.editSubmitLoading = false
                if (res.code === 0){
                  this.$message({
                    message: res.message,
                    type: 'success'
                  })
                  this.rateEditFormVisible = false
                  this.submitSearchForm()
                } else {
                  this.$message.error(res.message)
                  this.rateEditFormVisible = false
                }
              })
            }else{
              //编辑操作
              rateApi.editRate(param).then(res => {
                this.editSubmitLoading = false
                if (res.code === 0){
                  this.$message({
                    message: res.message,
                    type: 'success'
                  })
                  this.rateEditFormVisible = false
                  this.submitSearchForm()
                } else {
                  this.$message.error(res.message)
                }
              })
            }
          })
        }
      })
    },
    //rate end
  },
  components: {
    Pagination,
    search,
    safetySearch,
    list,
    safetyList,
    add,
    addSafety,
    quickAdd,
    rateAdd,
    customizeView
  },
  created: function () {
    this.loadSelectItem()
  },
  mounted: function () {
    this.submitStationSearchForm();
    // this.restaurants = this.loadAll()
  },
  watch: {
    'editForm.feesTakeUpPile'() {
      if (this.editForm.feesTakeUpPile == 'N') {
        this.editForm.takeUpTime = 0
        this.editForm.takeUpPrice = 0
        this.editForm.takeUpAmountTop = 0
      }
    },
    'editForm.isParkingFee'() {
      if (this.editForm.isParkingFee == 'N') {
        this.editForm.parkingLotFee = 0
      }
    },
  },
  filters: {
    statusFilter(stationStatus) {
      const statusMap = {
        0: 'warning',
        1: 'primary',
        5: 'info',
        6: 'danger',
        50: 'success'
      }
      return statusMap[stationStatus]
    }
  }
}
</script>

<style scoped lang="less">
.el_search {
  background-color: teal;
  color: white;
}

.el_clear {
  background-color: darkorange;
  color: white;
}
.BaiduMap {
  height: 300px;

  div {
    height: 300px;
  }
}
.el-btn {
  /*float: right;*/
  margin-bottom: 15px;
}

/deep/ .search_form {
  .el-form-item__content {
    .el-input {
      width: auto;
    }
  }
}

/deep/ .el-dialog__body {
  padding: 10px 10px;
}

/deep/ .el-tabs__header {
  margin: 0 0 5px;
}

/deep/ .row_input {
  .el-form-item__content {
    .el-input {
      width: 100%;
    }
  }
}

/deep/ .row_input {
  .el-col {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
}

/deep/ .rows_input {
  .el-col {
    .el-form-item {
      margin-bottom: auto;
    }
  }
}

.el_row_input {
  .el_col_input {
    width: auto;
  }
}
/deep/.el-dialog{
  width: 900px;
}
/deep/ .edit_form {
  height: 600px;
  overflow: auto;

  .el-form-item__label {
    color: rgba(0, 0, 0, 0.47);
  }
}
/deep/ .diy-class {
  .el-form-item__content {
    line-height: 0px;
  }
}
#live2dcanvas {
  border: 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager.vue